import { Button, Tabs, TabsProps } from "antd";
import { useNavigate } from "react-router-dom";

import {
  ContractorContractsTable,
  ContractorContactListTable,
  ContractorEdit,
} from "components/contractors";
import { useCurrentContractor } from "helpers/useCurrentContractor";
import { RouteLinks } from "services/router.service";
import backIcon from "data/icons/arrow-left.svg";

import "./ContractorPage.scss";

const tabs: TabsProps[ "items" ] = [
  {
    key: "contracts",
    label: "Contracts",
  },
  {
    key: "contacts-list",
    label: "Contacts",
  },
];

const ContractorPage = () => {
  const navigate = useNavigate();

  const {
    activeTab,
    contracts,
    contactsList,
    getContactsList,
    onTabChange,
  } = useCurrentContractor();

  return (
    <div className="default-page-wrapper">
      <Button
        className="back-button"
        type="link"
        onClick={ () => navigate(RouteLinks.PROTECTED.CONTRACTORS.LIST) }
      >
        <img src={ backIcon } alt="" />
        Back
      </Button>

      <ContractorEdit />

      <Tabs
        items={ tabs }
        activeKey={ activeTab }
        onChange={ onTabChange }
      />

      {activeTab === "contracts" && (
        <ContractorContractsTable contracts={ contracts } />
      )}

      {activeTab === "contacts-list" && (
        <ContractorContactListTable
          contactsList={ contactsList }
          getContactsList={ getContactsList }
        />
      )}
    </div>
  );
};

export default ContractorPage;
